import script from "./AlternativeImageQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternativeImageQuestion.vue?vue&type=script&setup=true&lang=js"

import "./AlternativeImageQuestion.vue?vue&type=style&index=0&id=07fbdbaf&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07fbdbaf"]])

export default __exports__